import axios from "axios";
import moment from "moment";
import toastr from "toastr";
import { URL, apiV1 } from "../constants";
const urlV1 = URL ;
let refreshThreshold = moment().add(55, 'minutes');
const axiosInstance = axios.create({
    baseURL: urlV1
});
let retry = false;
const intercept = (store, logoutAction, history) => {
    axios.defaults.baseURL = urlV1;

    let user = JSON.parse(localStorage.getItem("user"));
    if (!user) history.push('/login');

    axios.interceptors.response.use((response) => { // intercept the global error


        if (response.token) {
            localStorage.setItem("token", response.token);
        }
        if (response.identityId) {
            localStorage.setItem("identityId", response.identityId);
        }
        if (response && response.data && response.data.code === '401') {
            store.dispatch(logoutAction());
        }
        return response;
    }, function (error) {
      
        try {
            if (error && !error.response && error.message) {
                history.push(`/error?error=${error.stack}`)
                throw new Error(error.message);
            }

            if (error.response.status === 408 || error.code === 'ECONNABORTED') {
                toastr.error(`A timeout happend on url ${error.config.url}`);
                return;
            }

            if (error.response.status === 401 && !retry) { // if the error is 401 and hasent already been retried
                retry = true; // now it can be retried
                store.dispatch(logoutAction());
            }
            if (error.response.status === 404 && !retry) {
                retry = true;
                return
            }

            // Do something with response error
            return Promise.reject(error || "Something went wrong")
        } catch (err) {
            // toastr.error(`Some thing went wrong ${error}`);
            let error = err && err.message ? err = err.message : err;
            return Promise.reject(error ? { response: { data: { message: error } } } : "Something went wrong")
        }

    });

    axios.interceptors.request.use(async (config) => {
        let userData = JSON.parse(localStorage.getItem('user'));
        if (userData && userData.accessToken){
            config.headers.Authorization = `Bearer ${userData.accessToken}`
        }
       
        if (localStorage.refreshToken) {

            if (moment().isBefore(moment(store.getState().userAuthentication.user.exp)) || refreshThreshold.isBefore(moment())) {
                const response = await axiosInstance.get("/auth/refresh-token?token=" + localStorage.refreshToken);
                refreshThreshold = moment().add(55, 'minutes');
                const token = response.data.data.token;
                const identityId = response.data.data.identityId;
                localStorage.setItem("token", token);
                localStorage.setItem("identityId", identityId);
            }
            config.headers.token = localStorage.refreshToken;
            const isSuperAdminUser = localStorage.getItem('isSuperAdminUser');

            if (isSuperAdminUser) {
              config.headers.isSuperAdminUser = 'true';
            }

        }
        config.headers["Access-Control-Allow-Origin"] = '*'
       
        return config;
    }, function (error) {
        // Do something with request error
        return Promise.reject(error || "Something went wrong");
    });


};
export default intercept